<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" md="6" lg="6">
          <v-skeleton-loader
              class="mx-auto"
              height="100px"
              type="card"
              :loading="loader"
          >
          <v-card color="#9896c7" dark width="">
            <v-list-item three-line>
              <v-list-item-avatar tile color="#9896c7">
                <v-icon large dark>mdi-account-group-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="mb-1">
                  <span class="display-2">{{totalRegistered}}</span><span class="font-weight-regular">
                    Total Registered Issuers
                  </span>
                </v-list-item-title>
                <v-progress-linear value="100" color="white"></v-progress-linear>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6" lg="6">
          <v-skeleton-loader
              class="mx-auto"
              height="100px"
              type="card"
              :loading="loader"
          >
          <v-card color="#48c9b0" dark width="">
            <v-list-item three-line>
              <v-list-item-avatar tile color="#48c9b0">
                <v-icon large dark>mdi-file-document</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="mb-1"><span class="display-2 mr-1">{{totalReports}}</span><span class="font-weight-regular">
                  Total Reports Generated
                </span></v-list-item-title>
                <v-progress-linear value="100" color="white"></v-progress-linear>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12" lg="12">
          <v-card style="border-top: 3px solid">
            <v-toolbar color="white" light flat>
              <v-icon color="blue">mdi-chart-bar</v-icon>
              <v-toolbar-title class="ml-3">Issuers</v-toolbar-title>
            </v-toolbar>
            <v-row cols="12" lg="12" md="12" v-bind:key="index" v-for="(charts,index) in pieChartData">
              <v-col>
                <DonutPieChart :options="charts"></DonutPieChart>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DonutPieChart from "@/charts/DonutPieChart";
import {dataServices} from "@/services";

export default {
  name: 'Dashboard',
  components: {
    DonutPieChart
  },
  data () {
    return {
      viewChart: '',
      changePointChartState:'',
      tab: null,
      e13: 1,
      totalRegistered: '',
      totalReports: '',
      pieChartData:null,
      loader: true
    }
  },
  methods:{
    chartData: function (){
      dataServices.getChartData({customerType:null}).then(response => {
        this.pieChartData = null
        if (null !== response.dataResponse.testTakerData){
          this.totalRegistered = response.dataResponse.testTakerData.totalRegistered
          this.totalReports = response.dataResponse.testTakerData.totalReports
        }
        if (null !==response.dataResponse.chartData) {
          this.pieChartData = response.dataResponse.chartData
        }
        this.loader = false
      }).catch(error => {
        alert('Fail' + error)
      })
    },
    changeChartState: function () {
      this.viewChart = this.changePointChartState
    }
  },
  computed: {
    theme () {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
  },
  mounted() {
    this.chartData()
  }
}
</script>
<style scoped>
  .v-stepper--vertical .v-stepper__step {
    padding: 15px 25px 0px;
  }

  .cardStyle {
    border: 3px solid green;
  }

  .v-breadcrumbs {
    padding: 7px 0px 0px 0px !important;
  }

  .v-card__text, .v-card__title {
    padding: 5px;
    padding-left: 10px;
  }


</style>
<style>
  .theme--dark.v-label {
    color: rgba(255, 255, 255, 1) !important;
    font-weight: bolder;
  }
  .v-btn__content {
    font-weight: bolder !important;
  }
  .info-data {
    font-size: 14px;
    margin-top: -10px;
  }
</style>
